import React from "react";
import { SetBarChartProps } from "../types/dashboard";
import YearSelector from "./parts/YearSelector";
import SetBarHeader from "./parts/SetBarHeader";
import ChartContainer from "./parts/ChartContainer";
import DataTable, { BusinessType } from "./parts/DataTable";
import { useSetBarChartData } from "../hooks/useBarChartData";

interface Props extends SetBarChartProps {
  selectedYear: number;
  onYearChange: (increment: number) => void;
}

const SetBarChart: React.FC<Props> = ({
  dashboardData,
  selectedYear,
  onYearChange,
}) => {
  const { orders, sales, tableRows, headCells } =
    useSetBarChartData(dashboardData, selectedYear);

  const businessType =
    (sessionStorage.getItem("business_type") as BusinessType) || "";

  return (
    <div className="bg-gray-50 rounded-2xl shadow-xl border border-gray-300/60 p-4 w-full">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4">
        <SetBarHeader selectedYear={selectedYear} />

        <div className="flex flex-col sm:flex-row gap-3">
          <YearSelector
            selectedYear={selectedYear}
            onYearChange={onYearChange}
          />
        </div>
      </div>
      <div className=" gap-4 mb-2">
  {/* Cancelled */}
  {/* {dashboardData?.cancelled_summary && (
    <YearlyCancelledCard data={dashboardData.cancelled_summary} />
  )} */}
</div>

      {/* Two charts side by side */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* Orders Chart - Left Side */}
        <ChartContainer
          chartData={orders}
          isSalesView={false}
        />
        
        {/* Sales Chart - Right Side */}
        <ChartContainer
          chartData={sales}
          isSalesView={true}
        />
      </div>

      {/* Table */}
      <div className="w-full overflow-hidden">
        <DataTable
          tableRows={tableRows}
          headCells={headCells}
          businessType={businessType}
        />
      </div>
    </div>
  );
};

export default SetBarChart;
